import {createContext, useContext, useEffect} from "react";
import useDiscountState from "../zustand/discountState";
import useInfoState from "../zustand/infoState";
import usePaymentCheckoutState from "../zustand/payment/checkout/paymentCheckoutState";
import { usePaymentCheckoutAboBasicState } from "../zustand/payment/checkout/paymentCheckoutAboBasicState";
import { usePaymentCheckoutAboDuoState } from "../zustand/payment/checkout/paymentCheckoutAboDuoState";
import { usePaymentCheckoutAboFamilyState } from "../zustand/payment/checkout/paymentCheckoutAboFamilyState";

export const InfoContext: any = createContext(null);

declare var window: any;

export const InfoProvider = ( { children, abo, aboBasic, aboFamily, aboDuo, abo6m } ) => {

    const setAboPriceBefore = useDiscountState(s => s.setAboPriceBefore);
    const setAbo = useInfoState(s => s.setAbo);
    const setAboDuo = useInfoState(s => s.setAboDuo);
    const setAboFamily = useInfoState(s => s.setAboFamily);
    const setAboBasic = useInfoState(s => s.setAboBasic);
    const setAbo6m = useInfoState(s => s.setAbo6m);

    const setAboProduct = usePaymentCheckoutAboBasicState(s => s.setProduct);
    const setAboDuoProduct = usePaymentCheckoutAboDuoState( s => s.setProduct);
    const setAboFamilyProduct = usePaymentCheckoutAboFamilyState(s => s.setProduct);

    const setCurrentProduct = usePaymentCheckoutState(s => s.setCurrentProduct);

    useEffect(
        () => {
            if (abo) {
                setAboPriceBefore(abo.priceBefore);

                setAbo(abo);
                setAboProduct(abo);
                setAboBasic(aboBasic);
                setAbo6m(abo6m);

                setAboDuo(aboDuo);
                setAboDuoProduct(aboDuo);

                setAboFamily(aboFamily);
                setAboFamilyProduct(aboFamily);

                // initial set selected current product to duo
                setCurrentProduct(aboBasic);
            }
        },
        [ abo ]
    );

    const contextValue = {
        abo,
        aboBasic,
        aboFamily,
        aboDuo,
        abo6m
    };

    if (typeof window !== 'undefined') {
        window.abo = abo;
        window.aboFamily = aboFamily;
        window.aboDuo = aboDuo;
        window.aboBasic = aboBasic;
        window.abo6m = abo6m;
    }

    return <InfoContext.Provider value={contextValue}>
            {children}
        </InfoContext.Provider>;

}

export const useInfoContext = (): any => {
    return useContext(InfoContext);
}
